function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcResearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.424a6.424 6.424 0 1 1 11.248 4.242l2.631 2.631a.411.411 0 1 1-.582.582l-2.631-2.63A6.422 6.422 0 0 1 0 6.424m2.953-1.13.174-.3.604.348a2.9 2.9 0 0 0 0 2.163l-.604.349-.174-.301a.411.411 0 0 0-.711.412l.756 1.31a.411.411 0 0 0 .712-.412l-.173-.3.605-.349a2.9 2.9 0 0 0 1.87 1.081v.698h-.344a.412.412 0 0 0 0 .823H7.18a.412.412 0 1 0 0-.823h-.344v-.698a2.9 2.9 0 0 0 1.87-1.08l.605.349-.173.3a.411.411 0 0 0 .712.41l.756-1.31a.411.411 0 0 0-.711-.411l-.174.3-.604-.348a2.9 2.9 0 0 0 0-2.163l.604-.348.174.3a.411.411 0 0 0 .711-.411l-.756-1.31a.411.411 0 0 0-.712.411l.173.3-.605.349a2.9 2.9 0 0 0-1.87-1.08v-.699h.344a.412.412 0 1 0 0-.823H5.668a.412.412 0 1 0 0 .823h.344v.698a2.9 2.9 0 0 0-1.87 1.08l-.605-.348.173-.3a.411.411 0 0 0-.712-.412l-.756 1.31a.411.411 0 0 0 .711.412M5.74 7.572a.346.346 0 1 0-.489-.49.346.346 0 0 0 .489.49m.472-1.023a.566.566 0 1 0-.802-.8.566.566 0 0 0 .802.8m.757 1.07a.49.49 0 1 0-.693-.693.49.49 0 0 0 .693.693M4.955 4.955A2.076 2.076 0 1 0 7.89 7.893a2.076 2.076 0 0 0-2.935-2.938m5.43-2.492a5.6 5.6 0 1 0-7.92 7.92 5.6 5.6 0 1 0 7.92-7.92",
    fill: "#355C72",
    style: {
      fill: "#355c72",
      fill: "color(display-p3 .2078 .3608 .4471)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResearch);
export default __webpack_public_path__ + "static/media/ic_research.3c2008375e3e1e09c178aac872b0e041.svg";
export { ForwardRef as ReactComponent };